import { render, staticRenderFns } from "./IconCalendarPlus.vue?vue&type=template&id=fc0e88cc"
import script from "./IconCalendarPlus.vue?vue&type=script&lang=js"
export * from "./IconCalendarPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports